import * as React from "react";
import type { SVGProps } from "react";
const SvgClipboardWithInformation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 17c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-1v-4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1h1v3h-1c-.55 0-1 .45-1 1M11.62 9.92c.12.06.25.08.38.08.26 0 .52-.11.71-.29q.135-.15.21-.33c.06-.12.08-.25.08-.38 0-.26-.11-.52-.29-.71a1 1 0 0 0-1.09-.21q-.18.075-.33.21c-.18.19-.29.45-.29.71 0 .13.03.26.08.38q.075.18.21.33.15.135.33.21"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2a4 4 0 0 0-3.465 2H5c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-3.535A4 4 0 0 0 12 2m1.73 3c-.347-.597-.994-1-1.73-1s-1.383.403-1.73 1zM9 7c-.55 0-1-.45-1-1H6v14h12V6h-2c0 .55-.45 1-1 1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClipboardWithInformation;
